import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Footer from './components/Footer';

const PrivacyPage = () => {
  return (
    <div className="app-container" data-theme="dark" style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem 1.5rem' }}>
        <Link to="/">
          <Button variant="ghost" style={{ marginBottom: '1.5rem' }} data-testid="privacy-back-btn">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Voltar ao inicio
          </Button>
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '2rem' }}>
          <Shield className="w-8 h-8" style={{ color: '#00ffff' }} />
          <h1 style={{ fontSize: '1.75rem', fontWeight: '700' }}>Política de Privacidade</h1>
        </div>

        <div style={{ color: '#ccc', lineHeight: '1.8', fontSize: '0.95rem' }}>
          <p style={{ color: '#888', marginBottom: '2rem' }}>Última atualização: Dezembro de 2025</p>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>1. Introdução</h2>
            <p>A <strong>VLM Corp.</strong>, fundadora da <strong>Atlas.IA</strong>, com dominio em <strong>https://atlasaifinances.com</strong>, está comprometida com a proteção da privacidade de seus usuários. Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações pessoais.</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>2. Dados Coletados</h2>
            <p>Coletamos os seguintes tipos de dados:</p>
            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}><strong>Dados de cadastro:</strong> nome, e-mail e senha (criptografada).</li>
              <li style={{ marginBottom: '0.5rem' }}><strong>Dados do negocio:</strong> tipo de negócio, receita, despesas e demais informações fornecidas voluntariamente no perfil empresarial.</li>
              <li style={{ marginBottom: '0.5rem' }}><strong>Dados de uso:</strong> histórico de conversas com a IA, análises realizadas e créditos consumidos.</li>
              <li style={{ marginBottom: '0.5rem' }}><strong>Dados de pagamento:</strong> processados de forma segura pelo Stripe. Não armazenamos dados de cartão de crédito em nossos servidores.</li>
              <li style={{ marginBottom: '0.5rem' }}><strong>Arquivos enviados:</strong> documentos financeiros enviados para análise pela IA.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>3. Uso dos Dados</h2>
            <p>Utilizamos seus dados para:</p>
            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>Fornecer consultoria financeira personalizada através da inteligência artificial.</li>
              <li style={{ marginBottom: '0.5rem' }}>Processar pagamentos e gerenciar assinaturas.</li>
              <li style={{ marginBottom: '0.5rem' }}>Melhorar a qualidade do serviço e a experiência do usuário.</li>
              <li style={{ marginBottom: '0.5rem' }}>Enviar comunicações relevantes sobre o servico.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>4. Compartilhamento de Dados</h2>
            <p>Não vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros, exceto:</p>
            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}><strong>Stripe:</strong> para processamento seguro de pagamentos.</li>
              <li style={{ marginBottom: '0.5rem' }}><strong>OpenAI:</strong> para processamento das consultas de IA (dados anonimizados).</li>
              <li style={{ marginBottom: '0.5rem' }}><strong>Obrigação legal:</strong> quando exigido por lei ou ordem judicial.</li>
            </ul>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>5. Segurança dos Dados</h2>
            <p>Empregamos medidas de segurança técnicas e organizacionais, incluindo criptografia de senhas (bcrypt), transmissão segura (HTTPS) e armazenamento protegido em banco de dados.</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>6. Seus Direitos (LGPD)</h2>
            <p>De acordo com a Lei Geral de Proteção de Dados (Lei 13.709/2018), você tem direito a:</p>
            <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>Acessar seus dados pessoais.</li>
              <li style={{ marginBottom: '0.5rem' }}>Corrigir dados incompletos ou desatualizados.</li>
              <li style={{ marginBottom: '0.5rem' }}>Solicitar a exclusão de seus dados.</li>
              <li style={{ marginBottom: '0.5rem' }}>Revogar o consentimento a qualquer momento.</li>
              <li style={{ marginBottom: '0.5rem' }}>Solicitar portabilidade dos dados.</li>
            </ul>
            <p style={{ marginTop: '0.5rem' }}>Para exercer seus direitos, entre em contato: <a href="mailto:suporteatlasia@hotmail.com" style={{ color: '#00ffff' }}>suporteatlasia@hotmail.com</a></p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>7. Cookies</h2>
            <p>Utilizamos cookies e armazenamento local (localStorage) para manter sua sessão ativa e preferências de tema. Não utilizamos cookies de rastreamento de terceiros.</p>
          </section>

          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.2rem', fontWeight: '600', marginBottom: '0.75rem' }}>8. Contato</h2>
            <p>Para dúvidas sobre esta política, entre em contato:</p>
            <p style={{ marginTop: '0.5rem' }}><strong>VLM Corp.</strong> - Fundadora da Atlas.IA</p>
            <p>Email: <a href="mailto:suporteatlasia@hotmail.com" style={{ color: '#00ffff' }}>suporteatlasia@hotmail.com</a></p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
